// extracted by mini-css-extract-plugin
export default {"CircleButton":"CircleButton_CircleButton__varC7"};